import React from "react";
import ProductDetail from "../components/ProductDetail";

function ProductDetailPage() {
  return <ProductDetail />;
}

export default ProductDetailPage;
